import { ILPGOffersResponse } from "../model/ILPGOffersResponse";
import { IRequestCallback } from "../model/IRequestCallback";
import { IRequestCallbackResponse } from "../model/generated";
import { apiEndpoints } from "../consts";
import { dapiFetch } from "@origin-digital/daxi";
import { ConnectionAddressObject } from "@origin-digital/address-lookup";
import { ILPGOffersRequest } from "../model/ILPGOffersRequest";

export const getOffers = async (
  connectionAddressObject?: ConnectionAddressObject,
  offercode?: string
): Promise<ILPGOffersResponse> => {
  const method = "POST";
  const offersUrl = "/lpg/offers";
  const url = `${apiEndpoints.lpgPlans}${offersUrl}`;

  const { qasAddress: address, isManualAddress } =
    connectionAddressObject || {};

  try {
    const request: ILPGOffersRequest = {
      offercode,
      address: address && {
        streetNumber: address.streetNumber.toString(),
        street: `${address.streetName}${
          isManualAddress ? ` ${address.streetType}` : ""
        }`,
        suburb: address.city,
        postcode: address.postcode,
        state: address.state,

        unit: address.unitNumber ? address.unitNumber : undefined,
        unitType: address.unitType ? address.unitType : undefined,
      },
    };

    const fetchOptions = {
      method,
      body: request as any, // dapiFetch cannot handle possible undefines in type
    };
    const response = await dapiFetch<ILPGOffersResponse>(url, fetchOptions);
    console.log("Kasada Offers response:", response);
    return response.data as ILPGOffersResponse;
  } catch (error: any) {
    error.newRelic = `'GET: ${offersUrl}'`;
    throw error;
  }
};

export const postRequestCallback = async (
  callbackRequest: IRequestCallback
): Promise<IRequestCallbackResponse> => {
  const method = "POST";
  const requestCallbackUrl = "/lpg/offers/lead";
  const url = `${apiEndpoints.lpgPlans}${requestCallbackUrl}`;
  try {
    const fetchOptions = { method, body: callbackRequest as any };
    const response = await dapiFetch<IRequestCallbackResponse>(
      url,
      fetchOptions
    );
    return response.data as IRequestCallbackResponse;
  } catch (error: any) {
    error.newRelic = `'POST: ${requestCallbackUrl}'`;
    throw error;
  }
};
